<template>
  <div class="pt-kpis" :class="{ 'pt-kpis--futures': includeFutures }">
    <button
      type="button"
      class="pt-switch"
      :class="{ 'pt-switch--on': includeFutures }"
      role="switch"
      :aria-checked="includeFutures"
      @click="toggleFutures"
      title="Incluir long e short de futuros no PMP, volume, headRoom e coverage"
    >
      <span class="pt-switch__label">Futuros</span>
      <span class="pt-switch__opt" :class="{ 'is-active': !includeFutures }">OFF</span>
      <span class="pt-switch__opt" :class="{ 'is-active': includeFutures }">ON</span>
    </button>
    <div class="pt-kpi">
      <span class="pt-kpi__label">PMP Long:</span>
      <span class="pt-kpi__val text-orange">${{ formatUsd(pmp) }}</span>
    </div>
    <div class="pt-kpi">
      <span class="pt-kpi__label">Vol Long:</span>
      <span class="pt-kpi__val">{{ formatBtc(manualQty) }} BTC</span>
    </div>
    <div class="pt-kpi">
      <span class="pt-kpi__label">PMP Short:</span>
      <span class="pt-kpi__val text-purple">${{ formatUsd(hedgeAvg) }}</span>
    </div>
    <div class="pt-kpi">
      <span class="pt-kpi__label">Vol Short:</span>
      <span class="pt-kpi__val">{{ formatBtc(shortQty) }} BTC</span>
    </div>
    <div class="pt-kpi">
      <span class="pt-kpi__label">HeadRoom:</span>
      <span class="pt-kpi__val">{{ formatPct(headRoom) }}%</span>
    </div>
    <div class="pt-kpi">
      <span class="pt-kpi__label">Coverage:</span>
      <span class="pt-kpi__val" :class="coverageClass">{{ formatPct(coverage) }}%</span>
    </div>
    <div class="pt-kpi">
      <span class="pt-kpi__label">Net PnL:</span>
      <span class="pt-kpi__val" :class="netPnlClass">{{ formatPnl(netPnl) }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { usePortfolioToolbar } from './usePortfolioToolbar'

const {
  pmp,
  hedgeAvg,
  manualQty,
  shortQty,
  coverage,
  coverageTone,
  headRoom,
  netPnl,
  includeFutures,
  toggleFutures,
} = usePortfolioToolbar()

const coverageClass = computed(() => {
  if (coverageTone.value === 'good') return 'text-green'
  if (coverageTone.value === 'warn') return 'text-yellow'
  return 'text-red'
})

const netPnlClass = computed(() => (netPnl.value >= 0 ? 'text-green' : 'text-red'))

function formatUsd(value) {
  return Math.round(Number(value) || 0).toLocaleString('en-US')
}

function formatBtc(value) {
  return Number(value || 0).toFixed(4)
}

function formatPct(value) {
  return Number(value || 0).toFixed(1)
}

function formatPnl(value) {
  const n = Number(value) || 0
  const sign = n > 0 ? '+' : ''
  return `${sign}$${Math.round(n).toLocaleString('en-US')}`
}
</script>

<style scoped>
.pt-kpis {
  display: flex;
  gap: 16px;
  align-items: center;
  background: #0d1117;
  padding: 4px 12px;
  border-radius: 6px;
  border: 1px solid #21262d;
}

.pt-kpis--futures {
  border-color: #388bfd;
}

.pt-switch {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px;
  background: #161b22;
  border: 1px solid #30363d;
  border-radius: 999px;
  cursor: pointer;
}

.pt-switch--on {
  border-color: #388bfd;
}

.pt-switch__label {
  padding: 0 4px 0 6px;
  font-size: 10px;
  font-weight: 700;
  color: #8b949e;
}

.pt-switch--on .pt-switch__label {
  color: #58a6ff;
}

.pt-switch__opt {
  min-width: 28px;
  padding: 2px 6px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 700;
  color: #8b949e;
  text-align: center;
}

.pt-switch__opt.is-active {
  background: #30363d;
  color: #f0f6fc;
}

.pt-switch--on .pt-switch__opt.is-active {
  background: rgba(88, 166, 255, 0.2);
  color: #58a6ff;
}

.pt-kpi {
  display: flex;
  gap: 6px;
  font-size: 12px;
}

.pt-kpi__label {
  color: #8b949e;
}

.pt-kpi__val {
  font-weight: 600;
}

.text-orange { color: #f39c12; }
.text-purple { color: #9b59b6; }
.text-green  { color: #3fb950; }
.text-yellow { color: #e3b341; }
.text-red    { color: #f85149; }
</style>
